<template>
	<div class="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
		<!-- Simple Header with Logo -->
		<SimpleHeader />

		<!-- Main Content -->
		<main class="flex-1">
			<slot />
		</main>
	</div>
</template>

<script setup lang="ts">
import SimpleHeader from './SimpleHeader.vue';
// Minimal layout with simple header (logo only) - used for onboarding, wizard, fullscreen experiences, etc.
</script>

<style scoped>
/* Ensure full height layout */
:deep(body) {
	min-height: 100vh;
}
</style>
